import React from 'react';
import { ChevronRight } from 'lucide-react';
type BreadcrumbProps = {
  items: {
    label: string;
    href?: string;
  }[];
};
export function Breadcrumb({
  items
}: BreadcrumbProps) {
  return <nav aria-label="Breadcrumb" className="mb-8" data-id="element-1274" data-mp="1unnzstknrc7s">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm" data-id="element-1275" data-mp="1uluq15er0bvk">
        {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return <li key={item.label} className="flex items-center gap-2" data-id="element-1276" data-mp="24cfrr1ppxwip" data-mpi={index}>
              {item.href && !isLast ? <a href={item.href} className="font-medium text-ink-muted hover:text-navy transition-colors duration-150 rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal" data-id="element-1277" data-mp="29ah7pdrulfpy">
                  {item.label}
                </a> : <span aria-current="page" className="font-medium text-ink-dark" data-id="element-1278" data-mp="ny7fq12kr5lb">
                  {item.label}
                </span>}
              {!isLast && <ChevronRight size={14} aria-hidden="true" className="text-ink-muted" data-id="element-1279" data-mp="3qdqo65iko1ps" />}
            </li>;
      })}
      </ol>
    </nav>;
}